import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from '@reduxjs/toolkit';
import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Loader from 'carbon-react/lib/components/loader';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';

import RegisterForm from './RegisterForm';
import SuccessScreen from './SuccessScreen';
import Translate from '../../components/Translate/Translate';

import * as user from '../../redux/User/actions';

const Register = (props) => {
  const [email, setEmail] = useState('');
  const [protectionPassword, setProtectionPassword] = useState('');

  const handleSubmit = async (user) => {
    const { signup } = props;
    const { protectionPwd } = props.user;

    if (!protectionPwd) {
      return;
    }

    user.protectionPassword = protectionPwd;

    setEmail(user.email);
    signup(user);
  };

  const resendEmail = (email) => {
    props.resendEmail({ email });
  };

  const returnToSignUp = () => {
    props.setIsSubmitted(false);
  };

  const { error, isSubmitted, loading, protectionPwd } = props.user;

  return (
    <div className="register">
      {isSubmitted ? (
        <SuccessScreen email={email} resendEmail={resendEmail} returnToSignUp={returnToSignUp} />
      ) : (
        <div key="1" style={{ maxWidth: 450, margin: '0 auto', width: '100%' }}>
          {protectionPwd ? (
            <RegisterForm onSubmit={handleSubmit} protectionPwd={protectionPwd} />
          ) : (
            <div>
              {!!error && (
                <div style={{ marginBottom: 10 }}>
                  <Message variant="error">Invalid Password</Message>
                </div>
              )}
              <Textbox
                onChange={(e) => setProtectionPassword(e.target.value)}
                label={I18njs.t('auth.Pleaseinputpassword')}
                type="password"
              />
              <div style={{ textAlign: 'right' }}>
                <Button
                  as="primary"
                  htmlType="submit"
                  style={{ marginTop: '10px', marginRight: 0 }}
                  onClick={() => props.protectionPwdRequest(protectionPassword)}
                >
                  {loading ? <Loader isInsideButton /> : <Translate scope="auth.Next" />}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  const _user = bindActionCreators(user, dispatch);
  return {
    protectionPwdRequest: _user.protectionPwdRequest,
    setIsSubmitted: _user.registerSetSubmitted,
    signup: _user.registerRequest,
    resendEmail: _user.registerResendEmailRequest,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));
